import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../contexts/AdminContext';

const FullScreenLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-900 text-white">
    <p className="text-lg">Verifying Access...</p>
  </div>
);

export const AdminRouteGuard: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { isFounder, mfaEnrolled, loading } = useAdminAuth();
  const location = useLocation();

  if (loading) {
    return <FullScreenLoader />;
  }

  if (!isFounder) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Native GCIP: a founder without an enrolled second factor must set one up
  // before reaching the portal. Once enrolled, the factor is challenged at
  // sign-in, so a signed-in founder is MFA-verified by construction.
  if (!mfaEnrolled) {
    return <Navigate to="/mfa/setup" replace />;
  }

  return children;
};
